import * as React from "react";
import { Dropdown } from "./molecules/Dropdown";
import NewsCard from "./molecules/NewsCard";
import Pagination from "./molecules/Pagination";

const AllNews = ({ data, pageNumber, setPageNumber, setQuery, query }) => {
  return (
    <>
      <Dropdown query={query} setQuery={setQuery} />
      <div className="news_body">
        {data && data.hits.map((d, i) => <NewsCard data={d} key={i} />)}
      </div>
      <br />
      <Pagination
        className="pagination-bar"
        currentPage={pageNumber}
        totalCount={49 * 20}
        pageSize={20}
        onPageChange={(pageNumber) => setPageNumber(pageNumber)}
      />
    </>
  );
};
export default AllNews;
